export const hasPermittedFields = (obj: any): boolean => {
  return (
    obj && typeof obj === 'object' && obj.permittedFields && typeof obj.permittedFields === 'object'
  )
}

export const extractPermittedFields = (data: any): any => {
  if (!hasPermittedFields(data)) return data

  const extracted = { ...data }

  Object.entries(data.permittedFields).forEach(([fieldName, fieldData]: [string, any]) => {
    if (fieldData && typeof fieldData === 'object' && fieldData.value !== undefined) {
      if (extracted[fieldName] === undefined || extracted[fieldName] === null) {
        extracted[fieldName] = fieldData.value
      }
    }
  })

  return extracted
}
export const transformResponse = (response: any): any => {
  if (!response || typeof response !== 'object') {
    return response
  }

  // Handle arrays
  if (Array.isArray(response)) {
    return response.map((item) => transformResponse(item))
  }

  // Handle nested objects
  const transformed: any = {}

  Object.entries(response).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      transformed[key] = value.map((item) => transformResponse(item))
    } else if (value && typeof value === 'object') {
      transformed[key] = transformResponse(value)
    } else {
      transformed[key] = value
    }
  })

  return extractPermittedFields(transformed)
}
